import axios, { AxiosResponse } from 'axios';
import { isSettlementTransferLookupFailure, SettlementTransferLookupError } from '../features/settlementClassification/transferLookup';
import { MemberShipApiType } from './memberShip';
import { createDataObject } from '../lib/utils';
import { GENDERCODETYPE, OnboardingGoal } from '../lib/varialbe';

export /**
 * @method get
 * @brief 센터 멤버 조회
 * @link https://github.com/mustMoveProject/rappo-project/blob/RAPPO-1136/src/docs/Member.md#%EC%84%BC%ED%84%B0-%EB%A9%A4%EB%B2%84-%EC%A1%B0%ED%9A%8C
 */
const getOneMember = async (centerId: string, memberId: string, accessToken: string): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}/member/${memberId}`,
            headers: { authorization: accessToken },
        });

        if (response.status === 200) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        switch (error.response.status) {
            case 401:
                return { status: error.response.status };
            case 403:
                return { status: error.response.status };
            case 404:
                return { status: error.response.status };
            case 406:
                return { status: error.response.status };
            case 500:
                alert('서버 내부 오류');
                return { status: error.response.status };
        }
    }
};

export /**
 * @method patch
 * @brief 센터 회원 프로필 이미지 업로드
 * @link src/profile.md
 */
const patchMemberProfileImageAPI = async (
    centerId: string,
    memberId: string,
    imgBase64: string,
    accessToken: string
): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'patch',
            url: `${process.env.REACT_APP_SERVER}/v1/images/center/${centerId}/member/${memberId}/profile-image`,
            headers: { authorization: accessToken, 'Content-Type': 'application/json' },
            data: { imgBase64 },
        });

        if (response.status === 200) {
            return response;
        }
    } catch (error: any) {
        const status = error.response?.status;
        switch (status) {
            case 400:
                return { status, data: error.response?.data };
            case 401:
                return { status };
            case 403:
                return { status };
            case 404:
                return { status };
            case 406:
                return { status, data: error.response?.data };
            case 500:
                return { status: 500 };
            default:
                return { status: status ?? 500 };
        }
    }
    return response;
};

export /**
 * @method get
 * @brief 수업료 정산 회원별 조회 엑셀 추출용
 * @link https://github.com/mustMoveProject/rappo-project/blob/develop/src/docs/Member.md#%EC%88%98%EC%97%85%EB%A3%8C-%EC%A0%95%EC%82%B0-%ED%9A%8C%EC%9B%90%EB%B3%84-%EC%A1%B0%ED%9A%8C-%EC%97%91%EC%85%80-%EC%B6%94%EC%B6%9C%EC%9A%A9
 */
const getClassFeeSettlementExcel = async ({
    centerId,
    startDate,
    endDate,
    selectedCoach,
    accessToken,
}: GetClassFeeSettlementParamsType): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}/bymembership/excel?startDate=${startDate}&endDate=${endDate}&selectedCoach=${selectedCoach}`,
            headers: { authorization: accessToken },
        });

        if (response.status === 200) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        // 재등록 수업료용 양도 조회 실패(503) — 호출부가 빈 엑셀을 만들지 않게 표시를 실어 돌려준다.
        if (isSettlementTransferLookupFailure(error?.response?.status, error?.response?.data)) {
            return { status: 503, errorCode: error.response.data.errorCode };
        }
        switch (error.response.status) {
            case 401:
                return { status: error.response.status };
            case 403:
                return { status: error.response.status };
            case 404:
                return { status: error.response.status };
            case 406:
                return { status: error.response.status };
            case 500:
                alert('서버 내부 오류');
                return { status: error.response.status };
        }
    }
};
export /**
 * @method get
 * @brief 센터 멤버 조회
 * @link https://github.com/mustMoveProject/rappo-project/blob/RAPPO-1136/src/docs/Member.md#%EC%84%BC%ED%84%B0-%EB%A9%A4%EB%B2%84-%EC%A1%B0%ED%9A%8C
 */
const getClassFeeSettlement = async ({
    centerId,
    startDate,
    endDate,
    selectedCoach,
    accessToken,
}: GetClassFeeSettlementParamsType): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}/bymember?startDate=${startDate}&endDate=${endDate}&selectedCoach=${selectedCoach}`,
            headers: { authorization: accessToken },
        });

        if (response.status === 200) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        switch (error.response.status) {
            case 401:
                return { status: error.response.status };
            case 403:
                return { status: error.response.status };
            case 404:
                return { status: error.response.status };
            case 406:
                return { status: error.response.status };
            case 500:
                alert('서버 내부 오류');
                return { status: error.response.status };
        }
    }
};
export /**
 * @method get
 * @brief 수업료 정산 수강권별 조회
 * @link https://github.com/mustMoveProject/rappo-project/blob/RAPPO-1197/src/docs/Member.md#%EC%88%98%EC%97%85%EB%A3%8C-%EC%A0%95%EC%82%B0-%EC%88%98%EA%B0%95%EA%B6%8C%EB%B3%84-%EC%A1%B0%ED%9A%8C
 */
const getClassFeeSettlementForMembership = async ({
    centerId,
    startDate,
    endDate,
    selectedCoach,
    accessToken,
}: GetClassFeeSettlementParamsType): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}/bymembership?startDate=${startDate}&endDate=${endDate}&selectedCoach=${selectedCoach}`,
            headers: { authorization: accessToken },
        });

        if (response.status === 200) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        // 재등록 수업료용 양도 조회 실패(503) — 0원 화면 대신 오류 상태로 보이게 던진다(캐시되지 않는다).
        if (isSettlementTransferLookupFailure(error?.response?.status, error?.response?.data)) {
            throw new SettlementTransferLookupError();
        }
        switch (error.response.status) {
            case 401:
                return { status: error.response.status };
            case 403:
                return { status: error.response.status };
            case 404:
                return { status: error.response.status };
            case 406:
                return { status: error.response.status };
            case 500:
                alert('서버 내부 오류');
                return { status: error.response.status };
        }
    }
};

export /**
 * @method post
 * @brief 관리자가 임시회원 생성
 * @link https://github.com/mustMoveProject/rappo-project/blob/RAPPO-1180/src/docs/Member.md#%EA%B4%80%EB%A6%AC%EC%9E%90%EA%B0%80-%ED%9A%8C%EC%9B%90-%EC%83%9D%EC%84%B1
 */
const createTempMember = async ({
    accessToken,
    centerId,
    tempMember,
}: CreateTempMemberParamsType & { accessToken: string }): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;

    const data = await createDataObject(tempMember);
    try {
        response = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}`,
            headers: { authorization: accessToken },
            data,
        });

        if (response.status === 201) {
            return response;
        }
    } catch (error: any) {
        const status = error.response?.status;
        const data = error.response?.data;

        // Error 😨
        switch (status) {
            case 401:
                return { status, data };
            case 403:
                return { status, data };
            case 404:
                return { status, data };
            case 406:
                return { status, data };
            case 413: // 이미 있는경우 튕겨내야함
                return { status, data };
            case 500:
                alert('서버 내부 오류');
                return { status, data };
            default:
                return { status: status ?? 500, data };
        }
    }
};
export /**
 * @method delete
 * @brief 관리자가 임시회원 삭제
 * @link https://github.com/mustMoveProject/rappo-project/blob/RAPPO-1180/src/docs/Member.md#%EA%B4%80%EB%A6%AC%EC%9E%90%EA%B0%80-%ED%9A%8C%EC%9B%90-%EC%82%AD%EC%A0%9C
 */
const deleteTempMember = async ({
    memberId,
    centerId,
    accessToken,
    confirmShareCleanup,
    expectedItemIds,
}: DeleteTempMemberParamsType): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'delete',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}/member/${memberId}`,
            headers: { authorization: accessToken },
            // 공유 풀 정리는 관리자가 프리뷰를 확인했을 때만 보낸다. 안 보내면 서버가
            // 오늘과 똑같이 SHARE_OWNER_DISCONNECT_BLOCKED 로 막는다.
            ...(confirmShareCleanup
                ? {
                      params: {
                          confirmShareCleanup: true,
                          ...(expectedItemIds && expectedItemIds.length > 0
                              ? { expectedItemIds: expectedItemIds.join(',') }
                              : {}),
                      },
                  }
                : {}),
        });

        if (response.status === 204) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        // 공유 풀 소유자는 409 SHARE_OWNER_DISCONNECT_BLOCKED로 삭제가 막힌다.
        // 분기 없는 상태코드를 undefined로 삼키면 호출부가 결과를 구조분해하다 터져 무음 실패한다.
        return { status: error?.response?.status ?? 0, data: error?.response?.data };
    }
};
export /**
 * @method get
 * @brief 관리자 회원 등록시 휴대폰 인증
 * @linkhttps://github.com/mustMoveProject/rappo-project/blob/RAPPO-1180/src/docs/Member.md#%EA%B4%80%EB%A6%AC%EC%9E%90-%ED%9A%8C%EC%9B%90-%EB%93%B1%EB%A1%9D%EC%8B%9C-%ED%9C%B4%EB%8C%80%ED%8F%B0-%EC%9D%B8%EC%A6%9D
 * @description
 * 413 , 202 가 있음. 413 에서는 우리 센터에 등록되어 있는 경우여서 막아야 하고, 어떤 회원때문에 그런지 duplicateMember 로 내려준다.
 * 202 인 경우는 센터에서 등록하지 않은 회원이므로 가입할 수 있다.
 * 확인만 하는 API 이다
 * param에 000-0000-0000 형식으로 보내주시면 됩니다
 */
const getAuthentificationPhoneNumber = async ({
    centerId,
    phoneNumber,
    accessToken,
}: {
    centerId: string;
    phoneNumber: string;
    accessToken: string;
}): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_SERVER}/v1/members/center/${centerId}/phone-number-check/${phoneNumber}`,
            headers: { authorization: accessToken },
        });

        if (response.status === 202) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        switch (error.response.status) {
            case 401:
                return { status: error.response.status };
            case 403:
                return { status: error.response.status };
            case 404:
                return { status: error.response.status };
            case 406:
                return { status: error.response.status };
            case 413:
                // return { status: error.response.status };

                return { status: error.response.status, data: error.response.data };
            case 500:
                alert('서버 내부 오류');
                return { status: error.response.status };
        }
    }
};

export type CreateTempMemberParamsType = {
    centerId: string;
    tempMember: TempMemberType;
};
export type DeleteTempMemberParamsType = {
    accessToken: string;
    centerId: string;
    memberId: string;
    /** 소유 공유 풀을 정리하고 종료할지. 프리뷰를 확인했을 때만 true. */
    confirmShareCleanup?: boolean;
    /** 확인한 취소 대상 id 전체(풀 구분 없는 합집합). */
    expectedItemIds?: string[];
};

type WeightRecord = {
    value: number;
    recordDate: string; // ISO date string format
};

export type FacilitySubscriptionInfoType = {
    facilityProductId: string;
    productName: string;
    category: string;
    startDate: string;
    endDate: string;
    price: number;
    paymentMethod: string;
    paymentDate?: string;
    lockerNumber?: string | null;
    memo?: string;
};

type TempMemberType = {
    name: string;
    coachId: string;
    phoneNumber: string;
    memberType?: 'public' | 'temp' | 'original';
    gender?: GENDERCODETYPE;
    height?: number;
    weight?: number;
    address?: string;
    birthday?: string; // ISO date string format
    membershipInfo?: MemberShipApiType[];
    facilitySubscriptionInfo?: FacilitySubscriptionInfoType[];
    isSendAlimtalkToMember?: boolean; // 알림톡 전송 여부
    memo?: string;
};

export type GetClassFeeSettlementParamsType = {
    centerId: string;
    startDate: string;
    endDate: string;
    selectedCoach: string | 'all';
    accessToken: string;
};
